module.exports = __webpack_public_path__ + "static/media/cover-website-corpu.fe486d80.jpg";